import React, { useEffect, useState } from 'react';
import LanguageCard from 'components/Cards/LanguageCard';
import ToggleDetail from 'components/ToggleDetail';
import LanguageFormWrapper from 'components/Forms/LanguageFormWrapper';
import { connect } from 'react-redux';
import { SetLoading } from "redux/actions/loadingActions";
import { get } from 'services';
import WarningNotiifcation from 'components/WarningNotification';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Alerts from 'utils/alerts' 
import Spinner from 'react-bootstrap/Spinner'
import Navigation from "components/Navigation";
import ValidateToken from "components/ValidToken";

const LanguageModule = ({ user, SetLoading, history }) => {
  const [showDetail, setShowDetail] = useState(true);
  const [languageNames, setLanguageNames] = useState([]);
  const [languageLevels, setLanguageLevels] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async function mounted() {
      try {
        setIsLoading(true)
        const response = await get(`PersonaIdioma/GetByPersonaId/${user.persona.id}`);
        user.persona.personaIdiomas = response.data;
        if (user.persona.personaIdiomas && user.persona.personaIdiomas.length > 0 && user.persona.personaIdiomas.filter(x => x.estado != 0).length > 0) {
          setShowDetail(true);
        } else {
          setShowDetail(false);
        }

        const idiomas = await get('Idioma');
        const nivelIdiomas = await get('IdiomaNivel');
        setLanguageNames(idiomas.data);
        setLanguageLevels(nivelIdiomas.data);
      } catch (error) {
        Alerts.operationFail();
      } finally {
        setIsLoading(false);
      }
    })();

    return function cleanup() {
      setLanguageNames([]);
      setLanguageLevels([]);
    };
  }, [])

  return (
    <>
      <ValidateToken/>
      <div className={''}>
        {
          isLoading &&
          <div className={'display-flex flex-direction-row flex-center'}>
              <Spinner 
                  animation="grow" 
                  variant="primary" 
                  className={'is-absolute center-spinner-vertically'} 
                  size="lg" />
          </div>
        }
        <ToggleDetail initState={showDetail}  onToggleDetail={setShowDetail} label="Idiomas"/>
        { 
          showDetail ? 
          <div> 
            {
              
                (user.persona && user.persona.personaIdiomas && user.persona.personaIdiomas.length > 0 && user.persona.personaIdiomas.filter(x => x && x.estado == 1).length > 0) 
                ? (
                  user.persona.personaIdiomas.filter(x => x && x.estado == 1).map((language) => {
                    return <LanguageCard key={language.id} language={language} languageNames={languageNames} languageLevels={languageLevels}/>
                  })
                )
                : <Form.Group as={Col} md="12">
                <WarningNotiifcation message='No ha agregado  ' enphasis='idiomas'/>
              </Form.Group>
              
            }
            <Navigation beforeUrl="/education" continueUrl="/talents" />
          </div>
          : 
          <div> 
            <LanguageFormWrapper/>
          </div>
        }
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
      user: state.user
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    SetLoading: (value) => dispatch(SetLoading(value))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LanguageModule);